import {useCallback, useRef, useState} from 'react'
import {Button, Col, FloatingLabel, Form} from 'react-bootstrap'
import {PersonalLeadOneLead} from '../leadTypes'
import {
  AddressComponent,
  GooglePlacesAutocompleteInput,
  PlaceSelection,
} from '../../../components/GooglePlacesAutocompleteInput'
import {AddressSearchModal} from '../../../components/AddressSearchModal'

export const FormPersonalLead = ({info}: {info?: PersonalLeadOneLead | null}) => {
  const cityRef = useRef<HTMLInputElement | null>(null)
  const countryRef = useRef<HTMLInputElement | null>(null)
  const stateRef = useRef<HTMLInputElement | null>(null)
  const postalCodeRef = useRef<HTMLInputElement | null>(null)
  const streetAddressRef = useRef<HTMLInputElement | null>(null)
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false)
  const [modalInitialAddress, setModalInitialAddress] = useState<string>('')

  const getAddressPart = useCallback(
    (components: AddressComponent[] | undefined, types: string[]) => {
      if (!components || components.length === 0) return ''
      const component = components.find((item) => types.every((type) => item.types.includes(type)))
      return component?.long_name ?? ''
    },
    []
  )

  const handlePlaceSelect = useCallback(
    ({addressComponents, address}: PlaceSelection) => {
      if (address && streetAddressRef.current) {
        streetAddressRef.current.value = address
      }

      if (!addressComponents) return

      const city =
        getAddressPart(addressComponents, ['locality']) ||
        getAddressPart(addressComponents, ['postal_town']) ||
        getAddressPart(addressComponents, ['administrative_area_level_2'])
      const state = getAddressPart(addressComponents, ['administrative_area_level_1'])
      const country = getAddressPart(addressComponents, ['country'])
      const postalCode = getAddressPart(addressComponents, ['postal_code'])

      if (cityRef.current) cityRef.current.value = city || ''
      if (stateRef.current) stateRef.current.value = state || ''
      if (countryRef.current) countryRef.current.value = country || ''
      if (postalCodeRef.current) postalCodeRef.current.value = postalCode || ''
    },
    [getAddressPart]
  )

  const openAddressModal = useCallback(() => {
    const currentValue = streetAddressRef.current?.value ?? info?.streetAddress ?? ''
    setModalInitialAddress(currentValue)
    setIsAddressModalOpen(true)
  }, [info?.streetAddress])

  const closeAddressModal = useCallback(() => {
    setIsAddressModalOpen(false)
  }, [])

  return (
    <>
      <Col className='col-lg-6 col-md-6 col-12 mb-4'>
        <FloatingLabel controlId='birthDay' label='Date of Birth'>
          <Form.Control
            name='birthDay'
            type='date'
            placeholder='Date of Birth'
            defaultValue={info?.birthDay || undefined}
          />
        </FloatingLabel>
      </Col>
      <Col className='col-lg-6 col-md-6 col-12 mb-4'>
        <FloatingLabel controlId='civilStatus' label='Civil Status'>
          <Form.Control
            name='civilStatus'
            type='text'
            placeholder='Civil Status'
            defaultValue={info?.civilStatus || undefined}
          />
        </FloatingLabel>
      </Col>

      {/* Grupo 9 */}
      <Col className='col-lg-6 col-md-6 col-12 mb-4'>
        <FloatingLabel controlId='secondPhone' label='Second Phone'>
          <Form.Control
            type='text'
            name='secondPhone'
            placeholder='Second Phone'
            defaultValue={info?.secondPhone || undefined}
          />
        </FloatingLabel>
      </Col>
      <Col className='col-lg-6 col-md-6 col-12 mb-4'>
        <GooglePlacesAutocompleteInput
          name='streetAddress'
          type='text'
          placeholder='Street Address'
          defaultValue={info?.streetAddress || undefined}
          onPlaceSelect={handlePlaceSelect}
          ref={streetAddressRef}
        />
        <Button
          variant='outline-primary'
          size='sm'
          className='mt-2'
          type='button'
          onClick={openAddressModal}
        >
          Buscar dirección
        </Button>
      </Col>

      {/* Grupo 10 */}
      <Col className='col-lg-6 col-md-6 col-12 mb-4'>
        <FloatingLabel controlId='city' label='City'>
          <Form.Control
            name='city'
            type='text'
            placeholder='City'
            defaultValue={info?.city || undefined}
            ref={cityRef}
          />
        </FloatingLabel>
      </Col>
      <Col className='col-lg-6 col-md-6 col-12 mb-4'>
        <FloatingLabel controlId='country' label='Country'>
          <Form.Control
            name='country'
            type='text'
            placeholder='Country'
            defaultValue={info?.country || undefined}
            ref={countryRef}
          />
        </FloatingLabel>
      </Col>

      {/* Grupo 11 */}
      <Col className='col-lg-6 col-md-6 col-12 mb-4'>
        <FloatingLabel controlId='state' label='State'>
          <Form.Control
            type='text'
            name='state'
            placeholder='State'
            defaultValue={info?.state || undefined}
            ref={stateRef}
          />
        </FloatingLabel>
      </Col>
      <Col className='col-lg-6 col-md-6 col-12 mb-4'>
        <FloatingLabel controlId='postalCode' label='Postal Code'>
          <Form.Control
            name='postalCode'
            type='text'
            placeholder='Postal Code'
            defaultValue={info?.postalCode || undefined}
            ref={postalCodeRef}
          />
        </FloatingLabel>
      </Col>

      <AddressSearchModal
        show={isAddressModalOpen}
        onClose={closeAddressModal}
        onSelect={handlePlaceSelect}
        initialAddress={modalInitialAddress}
        modalTitle='Buscar dirección'
      />
    </>
  )
}
